import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Curso } from 'src/app/models/curso.model';
import { ApiService } from '../api.service';
import { daApi, listaDaApi, MAP_CURSO, ORDEM_CURSO, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class CursoService {

  constructor(
    public api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<CursosApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_CURSO, 'name');

    return this.api.get('/course' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_CURSO);
        return { cursos: lista.itens, numeroPaginas: lista.numeroPaginas } as CursosApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/course/${id}`).pipe(map((res: any) => daApi(res, MAP_CURSO)));
  }

  getBySlug(slug: string): Observable<any> {
    return this.api.get(`/course/slug/${slug}`).pipe(map((res: any) => daApi(res, MAP_CURSO)));
  }

  post(curso: Curso): Observable<any> {
    return this.api.post('/course', paraApi(curso, MAP_CURSO)).pipe(map((res: any) => daApi(res, MAP_CURSO)));
  }

  patch(curso: Curso): Observable<any> {
    return this.api.patch('/course', paraApi(curso, MAP_CURSO)).pipe(map((res: any) => daApi(res, MAP_CURSO)));
  }

  delete(curso: Curso): Observable<any> {
    return this.api.delete(`/course/${curso.id}`);
  }

  deleteSelected(cursos: Curso[]): Observable<any> {
    return this.api.deleteComCorpo('/course', cursos.map(c => ({ id: c.id })));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}

export interface CursosApi {
  cursos: Curso[];
  numeroPaginas: number;
}
